import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { getAdminDataService } from '../../services/adminDashboard';
import * as type from '../ActionTypes';
import {
  coderProfileDataByIdService,
  getAdminClientRecordService,
  getAdminCoderRecordService,
  getAdminDisputesService,
  getAdminJobRecordByIdService,
  getAdminJobRecordService,
  getAdminProposalRecordService,
  patchAdminClientRecordService,
  patchAdminCoderRecordService,
  putMilestoneRecordByAdminService
} from '../../services/admin';
import { getErrorMszOnFailure } from '../../helper/utils';
import { getCoderByIdService } from '../../services/profile/coder.service';

function* getAdminClientRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminClientRecordService, payload.params);
    if (adminData?.status === 200) {
      yield put({
        type: type.GET_ADMIN_CLIENT_SUCCESS,
        payload: adminData?.data
      });
    } else {
      yield put({
        type: type.GET_ADMIN_CLIENT_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_CLIENT_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* getAdminCoderRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminCoderRecordService, payload.params);
    if (adminData?.status === 200) {
      yield put({
        type: type.GET_ADMIN_CODER_SUCCESS,
        payload: adminData?.data
      });
    } else {
      yield put({
        type: type.GET_ADMIN_CODER_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_CODER_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* getAdminJobForClientRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminJobRecordService, {
      user: payload.params.currentClient.id,
      page: payload.params.page
    });

    const adminDataResult = adminData?.data.results;

    if (adminData?.status === 200) {
      if (payload.params.selectedLeftTab === 0) {
        yield put({
          type: type.GET_ADMIN_JOB_SUCCESS,
          data: adminData.data
        });
      }
      if (payload.params.selectedLeftTab === 1) {
        const openStatusArr = adminDataResult.filter((o: any) => {
          return (
            o.status == 'OPEN' &&
            o.contracts != null && {
              ...o,
              contracts: o.contracts.filter((o: any) => o.ended_by_client)
            }
          );
        });
        const competedStatusArr = adminDataResult.filter((o: any) => (o.status = 'COMPELTED'));

        const filterArr = [...openStatusArr, ...competedStatusArr];
        yield put({
          type: type.GET_ADMIN_JOB_SUCCESS,
          data: { ...adminData.data, results: filterArr }
        });
      }
      if (payload.params.selectedLeftTab === 2) {
        const openStatusArr = adminDataResult.filter((o: any) => {
          return (
            o.status == 'OPEN' &&
            o.contracts != null && {
              ...o,
              contracts: o.contracts.filter((o: any) => o.end_date == null)
            }
          );
        });
        const competedStatusArr = adminDataResult.filter((o: any) => (o.status = 'ACTIVE'));

        const filterArr = [...openStatusArr, ...competedStatusArr];
        yield put({
          type: type.GET_ADMIN_JOB_SUCCESS,
          data: { ...adminData.data, results: filterArr }
        });
      }
      if (payload.params.selectedLeftTab === 3) {
        const openStatusArr = adminDataResult.filter(
          (o: any) => o.status == 'OPEN' && o.contracts == null
        );
        yield put({
          type: type.GET_ADMIN_JOB_SUCCESS,
          data: openStatusArr
        });
      }
      if (payload.params.selectedLeftTab === 6) {
        const openStatusArr = adminDataResult.filter((o: any) => o.coders.length > 0);

        yield put({
          type: type.GET_ADMIN_JOB_SUCCESS,
          data: openStatusArr
        });
      }
    } else {
      const openStatusArr = adminDataResult.filter((o: any) => (o.status = 'CLOSED'));
      yield put({
        type: type.GET_ADMIN_JOB_SUCCESS,
        data: { ...adminData.data, results: openStatusArr }
      });
      yield put({
        type: type.GET_ADMIN_JOB_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_JOB_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}
function* getCoderDetailById(item: any): any {
  try {
    const coderData = yield all(
      item.contracts.map((o: any) => call(coderProfileDataByIdService, o.coder_id))
    );
    const checkStatus = coderData.every((o: any) => o.status === 200);
    if (checkStatus) {
      const coderFilterData = coderData.map((o: any) => o.data);
      const localArr = coderFilterData.map((o: any) => o.coderskillexperience.profile_picture);
      return { ...item, profileImageArr: localArr };
    }
  } catch (e: any) {
    return { ...item, profileImageArr: [] };
  }
}

function* getAdminJobRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminJobRecordService, payload.params);
    const adminDataArr = adminData?.data?.results ?? [];

    if (adminData?.status === 200 && adminDataArr.length > 0) {
      yield put({
        type: type.GET_ADMIN_JOB_SUCCESS,
        data: adminData.data
      });
    } else {
      yield put({
        type: type.GET_ADMIN_JOB_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_JOB_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* getAdminProposalJobRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminProposalRecordService, payload.params);
    if (adminData?.status === 200) {
      yield put({
        type: type.GET_ADMIN_PROPOSAL_JOB_SUCCESS,
        data: adminData?.data.results
      });
    } else {
      yield put({
        type: type.GET_ADMIN_PROPOSAL_JOB_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_PROPOSAL_JOB_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}
function* getAdminProposalByJobIdRecord(payload: any): any {
  try {
    const adminData = yield call(getAdminProposalRecordService, payload.params);

    if (adminData?.data?.results && adminData?.data?.results.length > 0) {
      const jobPostData = yield all(
        adminData.data?.results.map((o: any) => call(getAdminJobRecordByIdService, o.job_post))
      );
      const jobPostDataArr = jobPostData.map((o: any) => o.data);

      const jobPost_clientData = adminData?.data?.results.map((o: any, index: any) => ({
        ...o,
        jobData: jobPostDataArr[index]
      }));

      if (adminData?.status === 200 && jobPostData.length > 0 && jobPostData[0].status === 200) {
        yield put({
          type: type.GET_ADMIN_PROPOSAL_JOB_SUCCESS,
          data: jobPost_clientData
        });
      } else {
        yield put({
          type: type.GET_ADMIN_PROPOSAL_JOB_FAILURE,
          error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
        });
      }
    } else {
      yield put({
        type: type.GET_ADMIN_PROPOSAL_JOB_SUCCESS,
        data: []
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_PROPOSAL_JOB_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* getAdminCoderDetails(coderId: any): any {
  try {
    const adminData = yield call(coderProfileDataByIdService, coderId);
    if (adminData?.status === 200) {
      yield put({
        type: type.GET_CODER_DETAILS_SUCCESS,
        payload: adminData
      });
    } else {
      yield put({
        type: type.GET_CODER_DETAILS_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_CODER_DETAILS_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* patchAdminCoderRecord(action: any): any {
  try {
    const adminData = yield call(
      patchAdminCoderRecordService,
      action.params.data,
      action.params.id
    );
    if (adminData?.status === 200) {
      yield put({
        type: type.PATCH_ADMIN_CODER_SUCCESS,
        payload: true
      });
    } else {
      yield put({
        type: type.PATCH_ADMIN_CODER_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* patchAdminClientRecord(action: any): any {
  try {
    const adminData = yield call(
      patchAdminClientRecordService,
      action.params.data,
      action.params.id
    );
    if (adminData?.status === 200) {
      yield put({
        type: type.PATCH_ADMIN_CLIENT_SUCCESS,
        payload: true
      });
    } else {
      yield put({
        type: type.PATCH_ADMIN_CLIENT_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({ type: type.ADD_JOB_PROPOSAL_FAILURE, message: e.message });
    console.warn(e.message);
  }
}
function* getAdminDisputesRecords(payload: any): any {
  try {
    const adminData = yield call(getAdminDisputesService, payload.params);

    if (adminData?.status === 200) {
      yield put({
        type: type.GET_ADMIN_DISPUTES_SUCCESS,
        data: adminData?.data
      });
    } else {
      yield put({
        type: type.GET_ADMIN_DISPUTES_FAILURE,
        error: getErrorMszOnFailure(adminData?.data) || 'Oops, something went wrong!'
      });
    }
  } catch (e: any) {
    yield put({
      type: type.GET_ADMIN_DISPUTES_FAILURE,
      error: e.message || 'Oops, something went wrong!'
    });
    console.warn(e.message);
  }
}

function* adminSaga() {
  yield takeEvery(type.GET_ADMIN_CLIENT_REQUEST, getAdminClientRecord);
  yield takeEvery(type.PATCH_ADMIN_CLIENT_REQUEST, patchAdminClientRecord);

  yield takeEvery(type.GET_ADMIN_CODER_REQUEST, getAdminCoderRecord);
  yield takeEvery(type.PATCH_ADMIN_CODER_REQUEST, patchAdminCoderRecord);
  yield takeEvery(type.GET_CODER_DETAILS_REQUEST, getAdminCoderDetails);

  yield takeEvery(type.GET_ADMIN_JOB_REQUEST, getAdminJobRecord);
  yield takeEvery(type.GET_ADMIN_JOB_FOR_CLIENT_REQUEST, getAdminJobForClientRecord);

  yield takeEvery(type.GET_ADMIN_PROPOSAL_JOB_REQUEST, getAdminProposalJobRecord);
  yield takeEvery(type.GET_ADMIN_PROPOSAL_BY_JOB_ID_REQUEST, getAdminProposalByJobIdRecord);
  yield takeLatest(type.GET_ADMIN_DISPUTES, getAdminDisputesRecords);
}

export default adminSaga;
